const YEARS = ['1A', '2A', '3A', '4A', '5A-architecte', '5A-ecologue'] as const;
type yearType = (typeof YEARS)[number];

const yearMapping: Record<yearType, { label: string }> = {
    '1A': { label: '1ère année de bachelor' },
    '2A': { label: '2ème année de bachelor' },
    '3A': { label: '3ème année de bachelor' },
    '4A': { label: '1ère année de master' },
    '5A-architecte': { label: '2ème année de master - Architecte du paysage' },
    '5A-ecologue': { label: '2ème année de master - Écologue du paysage' },
};

const CURRENT_INSCRIPTION_YEAR = '2026';

const INSCRIPTION_FEE = 150;

const FIRST_INSCRIPTION_YEARS = ['before2023', '2023', '2024', '2025', '2026'] as const;
const SELECTABLE_FIRST_INSCRIPTION_YEARS = ['before2023', '2023', '2024', '2025'] as const;
type firstInscriptionYearType = (typeof FIRST_INSCRIPTION_YEARS)[number];
type selectableFirstInscriptionYearType = (typeof SELECTABLE_FIRST_INSCRIPTION_YEARS)[number];

const annualPriceMapping: Record<yearType, Record<firstInscriptionYearType, number>> = {
    '1A': { before2023: 8250, '2023': 8580, '2024': 8838, '2025': 8838, '2026': 8838 },
    '2A': { before2023: 8250, '2023': 8580, '2024': 8838, '2025': 8838, '2026': 8838 },
    '3A': { before2023: 8250, '2023': 8580, '2024': 8838, '2025': 8838, '2026': 8838 },
    '4A': { before2023: 8250, '2023': 8664, '2024': 8922, '2025': 8922, '2026': 8922 },
    '5A-architecte': { before2023: 4980, '2023': 5478, '2024': 5754, '2025': 5754, '2026': 5754 },
    '5A-ecologue': { before2023: 5990, '2023': 5990, '2024': 5990, '2025': 5990, '2026': 5990 },
};

const firstInscriptionYearsMapping: Record<selectableFirstInscriptionYearType, { label: string }> =
    {
        before2023: { label: "d'avant 2023" },
        '2023': { label: 'de 2023' },
        '2024': { label: 'de 2024' },
        '2025': { label: 'de 2025' },
    };

export {
    yearMapping,
    YEARS,
    FIRST_INSCRIPTION_YEARS,
    SELECTABLE_FIRST_INSCRIPTION_YEARS,
    firstInscriptionYearsMapping,
    annualPriceMapping,
    INSCRIPTION_FEE,
    CURRENT_INSCRIPTION_YEAR,
};
export type { yearType, firstInscriptionYearType, selectableFirstInscriptionYearType };
